


































































































































































































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppPrice from '~/components/partials/App/AppPrice.vue';
import ProductLabel from '~/components/partials/Product/ProductLabel.vue';
import { STOCK_NOTICE_BORDERLINE_COUNT, PRODUCT_CART_BUTTON } from '~/constants/products';
import { isInsidePeriod } from '~/utils';
import { ProductStockCard, ProductShowECResponseSchema } from '~/types/modules/product';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
    AppPrice,
    ProductLabel,
    ProductCartButton,
  },
  props: {
    data: {
      type: Object as PropType<ProductStockCard>,
      required: true,
    },
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    /**
     * 在庫数が表示される条件(全て満たす場合在庫数を表示)
     * ・在庫が6以下かどうか
     * ・抽選対象商品でない
     * ※抽選情報そのものが未定義の場合、falseを返すようにしました
     */
    const isShownStockCount = computed(
      () =>
        props.data.stock &&
        props.data.stock <= STOCK_NOTICE_BORDERLINE_COUNT &&
        !isInsidePeriod(
          props.data?.lottery?.raffle_control_start_time,
          props.data?.lottery?.raffle_control_end_time,
          true
        )
    );
    const hasDetail = computed(
      () =>
        props.data.vintageInfo ||
        props.data.vintageInfo2 ||
        props.data.tasteReview ||
        props.data.whenToDrink ||
        props.data.etiquetteImage ||
        props.data.howAging ||
        props.data.alcoholDegree ||
        props.data.awardInformation ||
        props.data.stopper ||
        props.data.brands.length > 0
    );

    return {
      props,
      isShownStockCount,
      hasDetail,
      PRODUCT_CART_BUTTON,
    };
  },
});
